(function () { function r(e, n, t) { function o(i, f) { if (!n[i]) { if (!e[i]) { var c = "function" == typeof require && require; if (!f && c) return c(i, !0); if (u) return u(i, !0); var a = new Error("Cannot find module '" + i + "'"); throw a.code = "MODULE_NOT_FOUND", a } var p = n[i] = { exports: {} }; e[i][0].call(p.exports, function (r) { var n = e[i][1][r]; return o(n || r) }, p, p.exports, r, e, n, t) } return n[i].exports } for (var u = "function" == typeof require && require, i = 0; i < t.length; i++)o(t[i]); return o } return r })()({
    1: [function (require, module, exports) {
      "use strict";

      // Cart Scripts
      // These apply to both the cart page and the flyout cart on every other page

      document.addEventListener('DOMContentLoaded', () => {
        // Initialize Flyout Cart
        const flyoutCart = document.querySelector('.js-flyout-cart');
        const flyoutCartToggles = document.querySelectorAll('.js-toggle-flyout-cart');
        flyoutCart.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));

        const formatMoney = (cents) => {
          if (cents % 100 === 0) {
            return `$${cents / 100}`;
          }
          return `$${(cents / 100).toFixed(2)}`;
        };

        // Main Update Function
        // Runs whenever a product in the cart is changed (added, removed, quantity changed)
        const updateFlyoutCart = () => {
          // Get updated cart data
          fetch('/cart.js').then(response => response.json()).then(async data => {
            // Update all cart total count badges
            document.querySelectorAll('.js-cart-count').forEach(badge => badge.textContent = data.item_count);

            // Update free shipping progress bar
            const freeShippingProgressBar = document.querySelector('.js-free-shipping-progress-bar');
            if (freeShippingProgressBar) {
              const freeShippingThreshold = freeShippingProgressBar.dataset.freeShippingThreshold;
              const freeShippingDifference = freeShippingThreshold - data.total_price;
              // Upate bar style based on progress
              const freeShippingProgress = Math.min(data.total_price / freeShippingThreshold, 1);
              freeShippingProgressBar.style.width = `${freeShippingProgress * 100}%`;
              // Update text based on progress
              const freeShippingProgressText = document.querySelector('.js-free-shipping-text');
              if (freeShippingDifference > 0) {
                freeShippingProgressText.textContent = `You're ${formatMoney(freeShippingDifference)} away from `;
              } else {
                freeShippingProgressText.textContent = "You've unlocked ";
              }
            }

            // Rebuild cart product list
            const cartProductsList = document.querySelector('.js-cart-item-list');
            let cartItemsHTML = '<li>No items here yet!</li>';
            if (data.items.length > 0) {
              const grouped = groupCartItemsByBundle(data.items);
              cartItemsHTML = '';
              Object.entries(grouped.bundles).forEach(_ref => {
                let [bundleKey, items] = _ref;
                cartItemsHTML += cartBundleTemplate(bundleKey, items);
              });
              grouped.singles.forEach(item => {
                cartItemsHTML += cartProductTemplate(item);
              });
            }
            cartProductsList.textContent = '';
            cartProductsList.insertAdjacentHTML('beforeend', cartItemsHTML);
            addEventListenersForCartItems();
            addEventListenersForBundleRemove();

            // Update checkout button based on rules
            let isValidCart = true;
            const cartAction = document.querySelector('.js-cart-action');
            const productData = await hydrateProductData(data.items);

            // Check if any items in the cart
            if (data.items.length == 0) {
              isValidCart = false;
              cartAction.textContent = '';
              cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatCheckoutPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled">
                    <p class="flyout-cart__action-text">Nothing here yet!</p>
                    </div>`);
            }

            // Check if perishable threshold has been met
            // Fetch product data for each item to see the tags
            const perishableThreshold = cartAction.dataset.perishableThreshold * 100;
            const perishableActionText = cartAction.dataset.perishableActionText || "Not enough perishable items to ship on ice. Please ensure the items labeled ‘perishable’ in the cart is at {amount} or more.";
            let totalPerishableAmount = 0;
            productData.forEach(product => {
              if (product.product.tags.includes('ships-ice')) {
                totalPerishableAmount += product.lineItem.final_line_price; // Make sure to use final_line_price to account for discounts
              }
            });

            if (totalPerishableAmount < perishableThreshold && totalPerishableAmount > 0) {
              isValidCart = false;
              cartAction.textContent = '';
              const formattedAmount = `$${perishableThreshold / 100}`;
              const message = perishableActionText.replace('{amount}', formattedAmount);
              cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatCheckoutPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled">
                    <p class="flyout-cart__action-text">${message}</p>
                    </div>`);
            }

            // Check if multiple Fresh & Wild catches are in the cart
            let fnwCatchIds = [];
            productData.forEach(product => {
              if (product.product.type == 'Fresh & Wild') {
                const sku = (product.lineItem.sku || '').toUpperCase();
                const catchMatch = sku.match(/^CATCH\d+/);
                const catchId = catchMatch ? catchMatch[0] : product.product.id;
                if (!fnwCatchIds.includes(catchId)) {
                  fnwCatchIds.push(catchId);
                }
              }
            });
            if (fnwCatchIds.length > 1) {
              isValidCart = false;
              cartAction.textContent = '';
              cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatCheckoutPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled fw">
                    <p class="flyout-cart__action-text">Fresh & Wild catches generally ship on different weeks. Please order each catch separately to proceed with your order.</p>
                    </div>`);
            }

            // This is old logic, and not in use now, but keeping for future - Check if an item must be ordered alone
            let mustOrderAloneProduct = null;
            productData.forEach(product => {
              if (product.product.tags.includes('must-order-alone')) {
                mustOrderAloneProduct = product;
              }
            });
            if (mustOrderAloneProduct && data.items.length > 1) {
              isValidCart = false;
              cartAction.textContent = '';
              cartAction.insertAdjacentHTML('beforeend', `<div class="flyout-cart__subtotal"><span class="flyout-cart__subtotal-text">Cart Subtotal</span> <span class="flyout-cart__subtotal-num">${formatCheckoutPrice(data.items_subtotal_price)}</span></div>
                    <div class="flyout-cart__checkout disabled">
                    <p class="flyout-cart__action-text">"${product.title}" is a special event and can only be ordered alone. Please remove any other products from your cart to continue.</p>
                    </div>`);
            }

            // Update checkout button based on validity
            if (isValidCart) {
              cartAction.textContent = '';
              cartAction.insertAdjacentHTML('beforeend', `<button data-cart-checkout class="btn btn--secondary flyout-cart__checkout" ${data.items.length > 0 ? '' : 'disabled'}" type="submit" name="checkout">
                    Checkout - <span class="js-cart-subtotal">${formatCheckoutPrice(data.items_subtotal_price)}</span>
                    </button>`);
            }

            // Update recommendations section if at least one product in the cart
            if (data.items.length > 0) {
              let productRecommendationsList = await getProductRecommendations(data);
              // Remove any recommendations that are already in the cart
              const cartProductIDs = data.items.map(item => item.product_id);
              productRecommendationsList.forEach((recommendation, index) => {
                if (cartProductIDs.includes(recommendation.id)) {
                  productRecommendationsList.splice(index, 1);
                }
              });

              // Remove any duplicate recommendations
              const uniqueRecommendations = [];
              productRecommendationsList.forEach(recommendation => {
                if (!uniqueRecommendations.some(item => item.id === recommendation.id)) {
                  uniqueRecommendations.push(recommendation);
                }
              });
              productRecommendationsList = uniqueRecommendations;

              // Randomize the array and limit to 4 items
              productRecommendationsList.sort(() => Math.random() - 0.5);
              productRecommendationsList.length = Math.min(productRecommendationsList.length, 4);

              // Add recommendations to the list and apply event listeners
              const recommendationsList = document.querySelector('.js-recommendations-list');
              recommendationsList.textContent = '';
              const lastIndex = productRecommendationsList.length - 1;
              const recommendationsHTML = productRecommendationsList.map((item, index) => cartRecommendationTemplate(item, index, lastIndex)).join('');
              recommendationsList.insertAdjacentHTML('beforeend', recommendationsHTML);
              // If only one recommendation, make it a single item carousel
              if (productRecommendationsList.length == 1) {
                recommendationsList.parentElement.classList.add('carousel__single');
              }
              addEventListenersForRecommendations();
            }
          }).catch(error => console.log(error));
        };

        // Fetch product data for each item in the cart
        async function hydrateProductData(lineItems) {
          const productData = await Promise.all(lineItems.map(async item => {
            const response = await fetch(`/products/${item.handle}.js`);
            const product = await response.json();
            return {
              product: {
                ...product
              },
              lineItem: {
                ...item
              }
            }; //include line item info for quantity details
          }));

          return productData;
        }

        // Build HTML for each product in the cart
        const cartProductTemplate = item => {
          const isFreeGift = item.properties && item.properties._seabear_free_gift === 'threshold-promotion';
          const displayPaidGiftVariantAtOriginalPrice = !isFreeGift && item._hasPromotionalGiftSibling;
          const lineItemKeys = (item._lineKeys || [item.key]).map(encodeURIComponent).join(',');
          return `
        <li class="flyout-cart__product${isFreeGift ? ' flyout-cart__product--free-gift' : ''}">
            <div class="flyout-cart__product-main">
              <a class="flyout-cart__product-image-wrap" href="${item.url}">
              <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" width="200" height="200" class="flyout-cart__product-image">
              </a>
              <div>
                <a href="${item.url}" class="flyout-cart__product-title">
                  ${item.title.split(' - ')[0]}
                </a>
                ${isFreeGift ? '<span class="flyout-cart__free-gift-badge">Free gift</span>' : ''}
                ${item.variant_title && item.variant_title != 'Default Title' ? `<p class="flyout-cart__product-subtitle">${item.variant_title}</p>` : ''}
                ${item.selling_plan_allocation ? `<p class="flyout-cart__product-subtitle subscription">(${item.selling_plan_allocation.selling_plan.name})</p>` : ''}
              </div>
            </div>
              ${isFreeGift ? '' : `<div class="flyout-cart__product-qty">
                <button type="button" class="flyout-cart__product-qty-btn js-qty-decrease">-</button>
                <input type="number" class="flyout-cart__product-qty-input js-qty-input" name="updates[]" value="${item.quantity}" data-line-item-keys="${lineItemKeys}" min="0" aria-label="Quantity">
                <button type="button" class="flyout-cart__product-qty-btn js-qty-increase">+</button>
              </div>`}
              <p class="flyout-cart__product-price">
                  ${isFreeGift
                    ? `${item.original_line_price > 0 ? `<s>${formatMoney(item.original_line_price)}</s>` : ''} <span class="flyout-cart__free-gift-price">Free</span>`
                    : displayPaidGiftVariantAtOriginalPrice
                      ? formatMoney(item.original_line_price)
                      : `${item.final_line_price < item.original_line_price
                              ? `<s>${formatMoney(item.original_line_price)}</s>`
                              : ''
                            }
                      ${formatMoney(item.final_line_price)}`}
              </p>
            ${isFreeGift ? '' : `<button type="button" class="flyout-cart__product-delete js-remove-product" data-line-item-keys="${lineItemKeys}">
              <span class="sr-only">Remove '${item.title}' from your cart</span>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.251 15.251">
                <g fill="none" stroke-linecap="round" stroke-width="1">
                <path d="M13.13 2.121L2.12176163 13.12923837M2.121 2.121l11.00823837 11.00823837"></path>
                </g>
              </svg>
            </button>`}
        </li>
        `;
        };
        function lineItemSignature(item) {
          const properties = item.properties || {};
          const sortedProperties = Object.keys(properties).sort().reduce((result, key) => {
            result[key] = properties[key];
            return result;
          }, {});
          const sellingPlanId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
            ? item.selling_plan_allocation.selling_plan.id
            : '';
          return `${item.variant_id}|${sellingPlanId}|${JSON.stringify(sortedProperties)}`;
        }
        function consolidateIdenticalItems(items) {
          const consolidated = [];
          const bySignature = {};
          items.forEach(item => {
            const signature = lineItemSignature(item);
            if (!bySignature[signature]) {
              const displayItem = {
                ...item,
                _lineKeys: [item.key]
              };
              bySignature[signature] = displayItem;
              consolidated.push(displayItem);
              return;
            }
            const displayItem = bySignature[signature];
            displayItem._lineKeys.push(item.key);
            displayItem.quantity += item.quantity;
            displayItem.original_line_price += item.original_line_price;
            displayItem.final_line_price += item.final_line_price;
          });
          return consolidated;
        }
        function groupCartItemsByBundle(items) {
          const bundles = {};
          const singles = [];
          const promotionalGiftVariantIds = new Set(items.filter(item => {
            return item.properties && item.properties._seabear_free_gift === 'threshold-promotion';
          }).map(item => Number(item.variant_id)));
          items.forEach(item => {
            if (item.properties && item.properties.bundle) {
              if (!bundles[item.properties.bundle]) bundles[item.properties.bundle] = [];
              bundles[item.properties.bundle].push(item);
            } else {
              singles.push(item);
            }
          });
          const consolidatedSingles = consolidateIdenticalItems(singles);
          consolidatedSingles.forEach(item => {
            const isFreeGift = item.properties && item.properties._seabear_free_gift === 'threshold-promotion';
            item._hasPromotionalGiftSibling = !isFreeGift && promotionalGiftVariantIds.has(Number(item.variant_id));
          });
          return {
            bundles,
            singles: consolidatedSingles
          };
        }
        function cartBundleTemplate(bundleKey, items) {
          // Helper to format price: show no decimals if .00, else show two decimals
          function formatPrice(amount) {
            const value = (amount / 100).toFixed(2);
            return value.endsWith('.00') ? `$${parseInt(value, 10)}` : `$${value}`;
          }
          // Use line item key for bundle removal
          const bundleKeys = items.map(item => item.key).join(',');
          return `
        <li class="flyout-cart__bundle" data-bundle="${bundleKey}" data-bundle-keys="${bundleKeys}">
          <div class="flyout-cart__bundle-label">Bundle ${bundleKey.replace('bundle_', '')}</div>
          <div class="flyout-cart__bundle-products">
            ${items.map(item => `
              <div class="flyout-cart__product">
              <div class="flyout-cart__product-main">
                <a class="flyout-cart__product-image-wrap" href="${item.url}">
                  <img src="${item.featured_image.url}" alt="${item.featured_image.alt}" width="200" height="200" class="flyout-cart__product-image">
                </a>
                <div class="flyout-cart__bundle-title-wrap">
                 <a href="${item.url}" class="flyout-cart__product-title">
                  ${item.title.split(' - ')[0]}
                </a>
                  ${item.variant_title && item.variant_title != 'Default Title' ? `<p class="flyout-cart__product-subtitle">${item.variant_title}</p>` : ''}
                  ${item.selling_plan_allocation ? `<p class="flyout-cart__product-subtitle subscription">(${item.selling_plan_allocation.selling_plan.name})</p>` : ''}

              <p class="flyout-cart__product-price">
                ${item.final_line_price < item.original_line_price ? `<s>${formatPrice(item.original_line_price)}</s>` : ''}
                ${formatPrice(item.final_line_price)}
              </p>
                </div>
              </div>
              <span class="flyout-cart__product-qty-static">Qty: ${item.quantity}</span>
              </div>
            `).join('')}
          </div>
          <button type="button" class="flyout-cart__bundle-remove js-remove-bundle" data-bundle="${bundleKey}">
            <span class="sr-only">Remove Bundle ${bundleKey.replace('bundle_', '')}</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.251 15.251"><g fill="none" stroke-linecap="round" stroke-width="1"><path d="M13.13 2.121L2.12176163 13.12923837M2.121 2.121l11.00823837 11.00823837"></path></g></svg>
          </button>
        </li>
      `;
        }

        // Get product recommendations
        const getProductRecommendations = async data => {
          const productRecommendationsURLs = data.items.map(item => `/recommendations/products.json?product_id=${item.product_id}&limit=2`);
          const productRecommendationsContainer = document.querySelector('.js-recommendations-list');
          const recommendationsData = await Promise.all(productRecommendationsURLs.map(async url => {
            const response = await fetch(url);
            const data = await response.json();
            return data;
          }));
          const productRecommendationsList = [];
          recommendationsData.forEach(recommendations => {
            productRecommendationsList.push(...recommendations.products);
          });
          return productRecommendationsList;
        };

        // Build HTML for cart recommendation items
        const cartRecommendationTemplate = (item, index, lastIndex) => {
          let variantSelect = '';
          if (item.variants.length > 1) {
            variantSelect = `
            <select name="id" class="flyout-cart__recommendations-select js-recommendations-select">
                ${item.variants.map(variant => {
              return `<option value="${variant.id}">${variant.title}</option>`;
            }).join('')}
            </select>`;
          } else {
            variantSelect = `<input class="js-recommendations-select" type="hidden" name="id" value="${item.variants[0].id}">`;
          }
          return `
        <li class="flyout-cart__recommendations-item js-product-recommendation-wrap carousel__slide ${index == lastIndex ? 'carousel__single' : ''}" id="carousel__slide${index}"
              tabindex="0" data-product-sku="${item.variants[0].sku}" data-product-title="${item.title}" data-product-price="${item.price / 100}">
            <div class="carousel__snapper">
                <div class="flyout-cart__recommendations-item-wrap">
                    <div class="flyout-cart__recommendations-item-content">
                        <a class="flyout-cart__recommendations-image-wrap" href="${item.url}">
                            <img src="${item.media[0].src}" alt="${item.media[0].alt}" width="200" height="200" class="flyout-cart__recommendations-image">
                        </a>
                        <div>
                            <a href="${item.url}" class="flyout-cart__recommendations-item-title">${item.title}</a>
                            <p class="flyout-cart__recommendations-price">
                                $${item.price / 100.00}
                            </p>
                        </div>
                    </div>
                    <div class="flyout-cart__recommendations-form">
                        ${variantSelect}
                        <button type="submit" class="flyout-cart__recommendations-add btn js-recommendation-add-to-cart">
                            Add to Cart - $${item.price / 100.00}
                        </button>
                    </div>
                    <a href="#carousel__slide${index == 0 ? lastIndex : index - 1}"
                        class="carousel__prev js-carousel-button" data-upcoming-slide="${index == 0 ? lastIndex : index - 1}"><span class="sr-only">Go to previous slide</span></a>
                    <a href="#carousel__slide${index == lastIndex ? 0 : index + 1}"
                        class="carousel__next js-carousel-button" data-upcoming-slide="${index == lastIndex ? 0 : index + 1}"><span class="sr-only">Go to next slide</span></a>
                </div>
            </div>
        </li>
        `;
        };

        // Add event listeners to cart recommendation items
        const addEventListenersForRecommendations = () => {
          document.querySelectorAll('.js-recommendation-add-to-cart').forEach(button => {
            button.addEventListener('click', event => {
              event.preventDefault();

              // Add 10% discount code if enabled by section settings
              const discountEnabled = document.querySelector('.js-flyout-cart-form').dataset.recommendationDiscountEnabled;
              const recommendationsDiscountCode = document.querySelector('.js-flyout-cart-form').dataset.recommendationsDiscountCode;
              if (discountEnabled) {
                fetch(`/discount/${recommendationsDiscountCode}`);
              }

              // Add product to cart
              const variantID = button.closest('.js-product-recommendation-wrap').querySelector('.js-recommendations-select').value;
              const data = {
                id: variantID,
                quantity: 1
              };
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
              }).then(response => response.json()).then(data => {
                // track the addition
                sendCustomRecommendationAddToCartEvent(data);
                // rerun update function to update cart
                updateFlyoutCart();
              });
            });
          });

          // Add event listeners for carousel buttons
          document.querySelectorAll('.js-carousel-button').forEach(button => {
            button.addEventListener('click', event => {
              const upcomingSlide = button.dataset.upcomingSlide;
              sendCustomRecommendationViewEvent(upcomingSlide);
            });
          });
        };
        document.addEventListener('free-gift:updated', updateFlyoutCart);

        // Function to open or close flyout cart
        // Used whenever user clicks on cart icon or adds an item to cart
        const toggleCart = (toggle, event) => {
          event.preventDefault();

          // Close cart when user clicks outside of it
          const closeFlyoutOnOutsideClick = event => {
            if (!flyoutCart.contains(event.target) && !toggle.contains(event.target)) {
              event.preventDefault(); // Don't click into any underlying elements
              flyoutCart.classList.remove('is-open');
              document.removeEventListener('click', closeFlyoutOnOutsideClick);
            }
          };
          if (flyoutCart.classList.contains('is-open')) {
            // We are closing the cart flyout
            flyoutCart.classList.remove('is-open');
            // document.removeEventListener('click', closeFlyoutOnOutsideClick);
          } else {
            // We are opening the cart flyout
            flyoutCart.classList.add('is-open');
            // document.addEventListener('click', closeFlyoutOnOutsideClick);
            sendCustomRecommendationViewEvent(0);
          }
        };
        // Event listener for all flyout cart toggle buttons
        flyoutCartToggles.forEach(toggle => toggle.addEventListener('click', event => toggleCart(toggle, event)));

        // Functions to handle adjusting quantity of items in flyout cart
        const increaseQuantity = event => {
          const input = event.target.parentElement.querySelector('input');
          input.value = parseInt(input.value) + 1;
          input.dispatchEvent(new Event('change'));
        };
        const decreaseQuantity = event => {
          const input = event.target.parentElement.querySelector('input');
          if (parseInt(input.value) > 1) {
            input.value = parseInt(input.value) - 1;
            input.dispatchEvent(new Event('change'));
          }
        };
        const addEventListenersForCartItems = () => {
          // Event listeners for all quantity buttons in flyout cart
          document.querySelectorAll('.js-qty-increase').forEach(button => button.addEventListener('click', event => increaseQuantity(event)));
          document.querySelectorAll('.js-qty-decrease').forEach(button => button.addEventListener('click', event => decreaseQuantity(event)));

          // On change listener for quantity input to adjust cart line item quantity
          document.querySelectorAll('.js-qty-input').forEach(input => {
            input.addEventListener('change', event => {
              const lineItemKeys = input.dataset.lineItemKeys.split(',').map(decodeURIComponent);
              const quantity = parseInt(input.value);
              const updates = {};
              lineItemKeys.forEach((key, index) => updates[key] = index === 0 ? quantity : 0);
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              }).then(response => response.json()).then(data => {
                updateFlyoutCart(data.item_count);
              }).catch(error => console.log(error));
            });
          });

          // Event listener for removing items from cart
          document.querySelectorAll('.js-remove-product').forEach(button => {
            button.addEventListener('click', event => {
              event.preventDefault();
              const lineItemKeys = button.dataset.lineItemKeys.split(',').map(decodeURIComponent);
              const updates = {};
              lineItemKeys.forEach(key => updates[key] = 0);
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              }).then(response => response.json()).then(data => {
                updateFlyoutCart();
              }).catch(error => console.log(error));
            });
          });
        };
        const addEventListenersForAddToCartBtns = () => {
          document.querySelectorAll('.js-product-form').forEach(form => {
            form.addEventListener('submit', event => {
              event.preventDefault();
              const data = new URLSearchParams(new FormData(form));
              fetch('/cart/add.js', {
                method: 'POST',
                body: data
              }).then(response => response.json()).then(() => {
                flyoutCart.classList.add('is-open');
                sendCustomRecommendationViewEvent(0);
                updateFlyoutCart();
              }).catch(error => console.log(error));
            });
          });
        };
        let BYM_BUNDLE_COUNTER = 1;
        function getNextBundleCounter(callback) {
          fetch('/cart.js').then(res => res.json()).then(data => {
            let maxBundleNum = 0;
            data.items.forEach(item => {
              if (item.properties && item.properties.bundle) {
                const match = item.properties.bundle.match(/bundle_(\d+)/);
                if (match && match[1]) {
                  const num = parseInt(match[1], 10);
                  if (num > maxBundleNum) maxBundleNum = num;
                }
              }
            });
            callback(maxBundleNum + 1);
          }).catch(() => {
            callback(1);
          });
        }
        const addEventListenersForBYMAddToCartBtns = () => {
          document.querySelectorAll('.bym--cart__add-to-cart').forEach(button => {
            button.addEventListener('click', event => {
              getNextBundleCounter(function (nextBundleNum) {
                const allTiers = Array.from(document.querySelectorAll('.bym--cart__tier'));
                let itemsToAdd = [];

                // Find the last filled tier and get its line item property
                let lastFilledTierElem = null;
                allTiers.forEach(tierElem => {
                  const productDiv = tierElem.querySelector('.bym--cart__tier-product-item');
                  if (productDiv) lastFilledTierElem = tierElem;
                });
                let lastLineItemProp = '';
                if (lastFilledTierElem) {
                  const lineItemEl = lastFilledTierElem.querySelector('.bym--cart__line-item-property');
                  if (lineItemEl && lineItemEl.textContent.trim() !== '') {
                    lastLineItemProp = lineItemEl.textContent.trim();
                  }
                }
                allTiers.forEach(tierElem => {
                  const productItems = tierElem.querySelectorAll('.bym--cart__tier-product-item');
                  productItems.forEach(productDiv => {
                    const infoDiv = productDiv.querySelector('.bym--cart__tier-product-info');
                    if (!infoDiv) return;
                    const title = infoDiv.querySelector('.bym--cart__tier-product-title')?.textContent;
                    const variantText = infoDiv.querySelector('.bym--cart__tier-product-variant')?.textContent;
                    let variantId = null;
                    let isBonus = productDiv.classList.contains('bym--cart__tier-bonus');
                    if (!isBonus) {
                      document.querySelectorAll('.bym-product').forEach(prod => {
                        const prodDataScript = prod.querySelector('script[data-product]');
                        if (!prodDataScript) return;
                        let prodData;
                        try {
                          prodData = JSON.parse(prodDataScript.textContent);
                        } catch (e) {
                          return;
                        }
                        if (prodData.title === title) {
                          if (variantText) {
                            const variantObj = prodData.variants.find(v => v.title === variantText);
                            if (variantObj) variantId = variantObj.id;
                          } else {
                            variantId = prodData.variants[0].id;
                          }
                        }
                      });
                      if (!variantId) return;
                      let properties = lastLineItemProp ? {
                        [lastLineItemProp]: true
                      } : {};
                      properties['bundle'] = `bundle_${nextBundleNum}`;
                      itemsToAdd.push({
                        id: variantId,
                        quantity: 1,
                        properties: Object.keys(properties).length ? properties : undefined
                      });
                    } else {
                      // Bonus product: get ID from data attribute
                      const bonusProductId = productDiv.dataset.bonusProductId;
                      const bonusLineItemProp = productDiv.dataset.bonusLineItemProp;
                      if (bonusProductId) {
                        let properties = bonusLineItemProp ? {
                          [bonusLineItemProp]: true
                        } : {};
                        properties['bundle'] = `bundle_${nextBundleNum}`;
                        itemsToAdd.push({
                          id: bonusProductId,
                          quantity: 1,
                          properties: Object.keys(properties).length ? properties : undefined
                        });
                      }
                    }
                  });
                });
                if (itemsToAdd.length === 0) return;
                // Debug log
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    items: itemsToAdd
                  })
                }).then(res => res.json()).then(() => {
                  flyoutCart.classList.add('is-open');
                  updateFlyoutCart();
                  // Clear BYM tiers after cart update
                  allTiers.forEach(tierElem => {
                    const tierProduct = tierElem.querySelector('.bym--cart__tier-product');
                    if (tierProduct) tierProduct.innerHTML = '';
                    const emptyTextWrap = tierElem.querySelector('.bym--cart__tier-empty-text-wrap');
                    if (emptyTextWrap) emptyTextWrap.style.display = '';
                    // Remove active class from tier
                    tierElem.classList.remove('active');
                    // Remove double-height class from tier
                    tierElem.classList.remove('double-height');
                  });
/* ===== RESET PROGRESS UI ===== */

document.querySelectorAll('.bym--cart__progress-label')
  .forEach(label => label.classList.remove('active'));

document.querySelectorAll('.bym--cart__progress-node')
  .forEach(node => node.classList.remove('active'));

const progressFill = document.querySelector('.bym--cart__progress-fill');
if (progressFill) {
  progressFill.style.width = '0%';
}

const progressBar = document.querySelector('.bym--cart__progress-bar');
if (progressBar) {
  progressBar.setAttribute('aria-valuenow', '0');
}

                  const motivateMsg = document.querySelector('.bym--cart__motivate-message');

if (motivateMsg) {
  const defaultHTML = motivateMsg.dataset.defaultHtml;
  motivateMsg.innerHTML = defaultHTML || '';
  motivateMsg.setAttribute('aria-hidden', 'false');
}
                  // Remove all markup from BYM Add to Cart button and disable it
                  const bymAddBtn = document.querySelector('.bym--cart__add-to-cart');
                  if (bymAddBtn) {
                    bymAddBtn.disabled = true;
                    bymAddBtn.innerHTML = 'Add to Cart';
                  }
                  // Remove bym--full class from .bym
                  const bymSection = document.querySelector('.bym');
                  if (bymSection) {
                    bymSection.classList.remove('bym--full');
                  }
                }).catch(err => {
                  console.error('Error adding BYM items to cart:', err);
                });
              });
            });
          });
        };
        function addEventListenersForBundleRemove() {
          document.querySelectorAll('.js-remove-bundle').forEach(button => {
            button.addEventListener('click', async event => {
              const bundleElem = button.closest('.flyout-cart__bundle');
              if (!bundleElem) return;
              const bundleKeys = bundleElem.getAttribute('data-bundle-keys');
              if (!bundleKeys) return;
              const keysArray = bundleKeys.split(',');
              const updates = {};
              keysArray.forEach(key => {
                updates[key] = 0;
              });
              try {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({
                    updates
                  })
                });
              } catch (err) {
                console.error('Error removing bundle keys:', keysArray, err);
              }
              bundleElem.remove();
              updateFlyoutCart();
            });
          });
        }

        // Initialize cart on page load
        addEventListenersForAddToCartBtns();
        addEventListenersForBYMAddToCartBtns();
        updateFlyoutCart();
      });
      const sendCustomRecommendationViewEvent = index => {
        const currentSlide = document.getElementById(`carousel__slide${index}`);
        if (currentSlide) {
          gtag('event', 'view_upsell_item', {
            'value': currentSlide.dataset.productPrice,
            'items': [{
              'id': currentSlide.dataset.productSku,
              'name': currentSlide.dataset.productTitle,
              'price': currentSlide.dataset.productPrice
            }]
          });
        }
      };
      const sendCustomRecommendationAddToCartEvent = product => {
        if (product) {
          gtag('event', 'add_upsell_item', {
            'value': product.price / 100,
            'items': [{
              'id': product.sku,
              'name': product.title,
              'price': product.price / 100
            }]
          });
        }
      };

      // Helper to format price for checkout button
      function formatCheckoutPrice(amount) {
        const value = (amount / 100).toFixed(2);
        return value.endsWith('.00') ? `$${parseInt(value, 10)}` : `$${value}`;
      }
    }, {}]
  }, {}, [1]);
